<app-section-wrapper-container>
	<div class="overview-sub-section">
		<app-summary-item [title]="'shared|pricing-section|duration'" useContent>
			<div class="flex items-center gap-2 flex-wrap">
				<app-date-range-pill
					class="-ml-2"
					[startsAt]="isoDateFrom()"
					[endsAt]="isoDateTo()" />
				<app-expires-at-pill [endsAt]="recordData()?.endsAt?.toISOString()" />
			</div>
		</app-summary-item>

		@if (recordData().externalReference) {
			<app-summary-item
				[title]="
					'road-taxes|record|details-section|field-label|external-reference'
				"
				[value]="recordData().externalReference" />
		}
	</div>

	<div class="flex gap-4 flex-col md:flex-row">
		@if (recordData().vehicleId) {
			<app-vehicle-link-card [id]="recordData().vehicleId" />
		}
	</div>
</app-section-wrapper-container>
